var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgBirthday = function SvgBirthday(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 7.96079V5.87256",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87574 5.87255C13.8975 4.48039 9.87574 1 9.87574 1C9.87574 1 5.69927 4.48039 9.87574 5.87255Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8346 11.2672C12.8346 12.0517 12.523 12.8042 11.9682 13.359C11.4134 13.9138 10.6609 14.2255 9.8763 14.2255C9.0917 14.2255 8.33924 13.9138 7.78444 13.359C7.22965 12.8042 6.91797 12.0517 6.91797 11.2672",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91667 11.2671C6.91666 12.0417 6.61285 12.7854 6.07049 13.3385C5.52812 13.8915 4.79048 14.2098 4.01602 14.2249C2.35752 14.2566 1 12.8675 1 11.2087V10.049C1 9.49516 1.22001 8.964 1.61163 8.57238C2.00325 8.18076 2.5344 7.96075 3.08824 7.96075H16.6618C17.2156 7.96075 17.7467 8.18076 18.1384 8.57238C18.53 8.964 18.75 9.49516 18.75 10.049V11.2087C18.75 12.8675 17.3925 14.2566 15.734 14.2249C14.9595 14.2098 14.2219 13.8915 13.6795 13.3385C13.1372 12.7854 12.8333 12.0417 12.8333 11.2671",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5325 13.6399V18.402C17.5325 18.5866 17.4591 18.7636 17.3286 18.8942C17.1981 19.0247 17.021 19.0981 16.8364 19.0981H2.91483C2.73022 19.0981 2.55317 19.0247 2.42263 18.8942C2.29209 18.7636 2.21875 18.5866 2.21875 18.402V13.6399",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBirthday;